// import React, { useState, useEffect } from "react";
// import "./Navbar.css";
// import {
//   BrowserRouter as Router,
//   NavLink,
//   Route,
//   Routes,
// } from "react-router-dom";

// import Home from "./Pages/Home";
// import About from "./Pages/About";
// import Contact from "./Pages/Contact";
// import Service from "./Pages/Service";
// import Products from "./Pages/Products";
// import Careers from "./Pages/Careers";
// import Footer from "../Footer/Footer";
// import logo3 from "../images/logo3.png";
// import ScrollToTop from "../ScrollToTop";
// import SoftwareDevelopment from "./Pages/SoftwareDevelopment";
// import DigitalMarketing from "./Pages/DigitalMarketing";
// import AIIntegration from "./Pages/AIIntegration";
// import CloudServices from "./Pages/CloudServices";
// import IoTServices from "./Pages/IoTServices";

// export default function Navbar() {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isFixed, setIsFixed] = useState(false);

//   const toggleMenu = () => setIsMenuOpen((prev) => !prev);
//   const closeMenuOnClick = () => isMenuOpen && setIsMenuOpen(false);

//   useEffect(() => {
//     const handleScroll = () => setIsFixed(window.scrollY > 80);
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   return (
//     <Router>
//       <ScrollToTop /> {/* <-- Add this line */}
//       <nav className={`ct-navbar ${isFixed ? "fixed" : ""}`}>
//         <div className="ct-navbar-inner">
//           {/* Logo */}
//           <div className="ct-navbar-logo">
//             <NavLink to="/" onClick={closeMenuOnClick}>
//               <img src={logo3} alt="Logo" className="ct-logo-image" />
//             </NavLink>
//           </div>

//           {/* Hamburger */}
//           <button
//             className={`ct-menu-btn ${isMenuOpen ? "open" : ""}`}
//             onClick={toggleMenu}
//             aria-label="Toggle navigation"
//           >
//             <span className="ct-menu-line" />
//             <span className="ct-menu-line" />
//             <span className="ct-menu-line" />
//           </button>

//           {/* Nav Links */}
//           <ul className={`ct-navbar-links ${isMenuOpen ? "active" : ""}`}>
//             {[
//               ["Home", "/"],
//               ["About", "/about"],
//               ["Services", "/service"],
//               ["Products", "/products"],
//               ["Careers", "/careers"],
//               ["Contact", "/contact"],
//             ].map(([label, path]) => (
//               <li key={path}>
//                 <NavLink
//                   to={path}
//                   end={path === "/"}
//                   onClick={closeMenuOnClick}
//                   className={({ isActive }) =>
//                     `ct-nav-link ${isActive ? "active" : ""}`
//                   }
//                 >
//                   {label}
//                 </NavLink>
//               </li>
//             ))}
//           </ul>
//         </div>
//       </nav>
//       {/* Routes */}
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/service" element={<Service />} />
//         <Route path="/products" element={<Products />} />
//         <Route path="/careers" element={<Careers />} />
//         <Route path="/contact" element={<Contact />} />
//         <Route path="/contact" element={<Contact />} />
//         <Route path="/SoftwareDevelopment" element={<SoftwareDevelopment />} />
//         <Route path="/DigitalMarketing" element={<DigitalMarketing />} />
//         <Route path="/AIIntegration" element={<AIIntegration />} />
//         <Route path="/CloudServices" element={<CloudServices />} />
//         <Route path="/IoTServices" element={<IoTServices />} />

//       </Routes>
//       <Footer />
//     </Router>
//   );
// }










import React, { useState, useEffect } from "react";
import "./Navbar.css";
import {
  BrowserRouter as Router,
  NavLink,
  Route,
  Routes,
} from "react-router-dom";

import Home from "./Pages/Home";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Service from "./Pages/Service";
import Products from "./Pages/Products";
import Careers from "./Pages/Careers";
import Footer from "../Footer/Footer";
// import logo3 from "../images/logo3.png";
// import logo4 from "../images/logo-4.png"
import logo4 from "../images/logo4.png"
import ScrollToTop from "../ScrollToTop";
import SoftwareDevelopment from "./Pages/SoftwareDevelopment";
import DigitalMarketing from "./Pages/DigitalMarketing";
import AIIntegration from "./Pages/AIIntegration";
import CloudServices from "./Pages/CloudServices";
import IoTServices from "./Pages/IoTServices";

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isFixed, setIsFixed] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
    // close services dropdown when toggling whole menu
    if (isMenuOpen) setIsServicesOpen(false);
  };

  const closeMenuOnClick = () => {
    if (isMenuOpen) setIsMenuOpen(false);
    setIsServicesOpen(false);
  };

  const toggleServicesDropdown = () => {
    // Mainly for mobile accordion
    setIsServicesOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleScroll = () => setIsFixed(window.scrollY > 80);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // helper for normal nav links
  const navLinkClass = ({ isActive }) =>
    `ct-nav-link ${isActive ? "active" : ""}`;

  return (
    <Router>
      <ScrollToTop />

      <nav className={`ct-navbar ${isFixed ? "fixed" : ""}`}>
        <div className="ct-navbar-inner">
          {/* Logo */}
          <div className="ct-navbar-logo">
            <NavLink to="/" onClick={closeMenuOnClick}>
              <img src={logo4} alt="Logo" className="ct-logo-image" />
            </NavLink>
          </div>

          {/* Hamburger */}
          <button
            className={`ct-menu-btn ${isMenuOpen ? "open" : ""}`}
            onClick={toggleMenu}
            aria-label="Toggle navigation"
          >
            <span className="ct-menu-line" />
            <span className="ct-menu-line" />
            <span className="ct-menu-line" />
          </button>

          {/* Nav Links */}
          <ul className={`ct-navbar-links ${isMenuOpen ? "active" : ""}`}>
            {/* Home */}
            <li>
              <NavLink
                to="/"
                end
                onClick={closeMenuOnClick}
                className={navLinkClass}
              >
                Home
              </NavLink>
            </li>

            {/* About */}
            <li>
              <NavLink
                to="/about"
                onClick={closeMenuOnClick}
                className={navLinkClass}
              >
                About
              </NavLink>
            </li>

            {/* SERVICES DROPDOWN */}
            <li className="ct-has-dropdown">
              <button
                type="button"
                className={`ct-nav-link ct-services-toggle ${
                  isServicesOpen ? "open" : ""
                }`}
                onClick={toggleServicesDropdown}
              >
                Services
                <span className="ct-chevron" aria-hidden="true">
                  ▾
                </span>
              </button>

              <div
                className={`ct-dropdown ${
                  isServicesOpen ? "open" : ""
                }`}
              >
                <NavLink
                  to="/service"
                  onClick={closeMenuOnClick}
                  className={({ isActive }) =>
                    `ct-dropdown-link ${isActive ? "active" : ""}`
                  }
                >
                  All Services
                </NavLink>
                <NavLink
                  to="/SoftwareDevelopment"
                  onClick={closeMenuOnClick}
                  className={({ isActive }) =>
                    `ct-dropdown-link ${isActive ? "active" : ""}`
                  }
                >
                  Software Development
                </NavLink>
                <NavLink
                  to="/DigitalMarketing"
                  onClick={closeMenuOnClick}
                  className={({ isActive }) =>
                    `ct-dropdown-link ${isActive ? "active" : ""}`
                  }
                >
                  Digital Marketing
                </NavLink>
                <NavLink
                  to="/AIIntegration"
                  onClick={closeMenuOnClick}
                  className={({ isActive }) =>
                    `ct-dropdown-link ${isActive ? "active" : ""}`
                  }
                >
                  AI Integration
                </NavLink>
                <NavLink
                  to="/CloudServices"
                  onClick={closeMenuOnClick}
                  className={({ isActive }) =>
                    `ct-dropdown-link ${isActive ? "active" : ""}`
                  }
                >
                  Cloud Services
                </NavLink>
                <NavLink
                  to="/IoTServices"
                  onClick={closeMenuOnClick}
                  className={({ isActive }) =>
                    `ct-dropdown-link ${isActive ? "active" : ""}`
                  }
                >
                  IoT Services
                </NavLink>
                
              </div>
            </li>

            {/* Products */}
            <li>
              <NavLink
                to="/products"
                onClick={closeMenuOnClick}
                className={navLinkClass}
              >
                Products
              </NavLink>
            </li>

            {/* Careers */}
            <li>
              <NavLink
                to="/careers"
                onClick={closeMenuOnClick}
                className={navLinkClass}
              >
                Careers
              </NavLink>
            </li>

            {/* Contact */}
            <li>
              <NavLink
                to="/contact"
                onClick={closeMenuOnClick}
                className={navLinkClass}
              >
                Contact
              </NavLink>
            </li>
          </ul>
        </div>
      </nav>

      {/* Routes */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/service" element={<Service />} />
        <Route path="/products" element={<Products />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/SoftwareDevelopment" element={<SoftwareDevelopment />} />
        <Route path="/DigitalMarketing" element={<DigitalMarketing />} />
        <Route path="/AIIntegration" element={<AIIntegration />} />
        <Route path="/CloudServices" element={<CloudServices />} />
        <Route path="/IoTServices" element={<IoTServices />} />
      </Routes>

      <Footer />
    </Router>
  );
}
